import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import classNames from 'classnames';
import { isCombinedModule, isRpmModule } from 'infrastructure/functions';
import { useTranslation } from 'react-i18next';
import { type FC } from 'react';

import { useControlButtons } from './hooks/useControlButtons';
import s from './styles.module.scss';

import type { ModuleType } from 'infrastructure/enums';

interface PatientControlPanelProps {
  patientGuid: string;
  module: ModuleType;
  clinicGuid?: string;
}

const PatientControlPanel: FC<PatientControlPanelProps> = ({
  patientGuid,
  module,
  clinicGuid,
}) => {
  const { t } = useTranslation();

  const { loading, controlButtons } = useControlButtons({
    patientGuid,
    module,
  });

  return (
    <div className={s.control} id="control-panel">
      <BaseSpinWrapper spinning={loading}>
        <div className={s['control-wrapper']}>
          <h4 className={s.title}>{t('labels.controlPanel')}</h4>
          <div className={s.divider} />
          <div
            className={classNames(s['control-buttons-wrapper'], {
              [s['control-buttons-wrapper-rpm']]:
                isRpmModule(module) || isCombinedModule(module),
            })}
          >
            {controlButtons.map(({ key, component: Component }) => (
              <Component
                key={key}
                module={module}
                patientGuid={patientGuid}
                clinicGuid={clinicGuid}
              />
            ))}
          </div>
        </div>
      </BaseSpinWrapper>
    </div>
  );
};
export default PatientControlPanel;
